import Head from "next/head";

const Meta = () => (
  <Head>
    <link rel="shortcut icon" href={`/images/${process.env.NEXT_PUBLIC_CUSTOMER}/favicon.ico`} />

    {process.env.NEXT_PUBLIC_FACEBOOK_DOMAIN_VERIFICATION && (
      <meta name="facebook-domain-verification" content={process.env.NEXT_PUBLIC_FACEBOOK_DOMAIN_VERIFICATION} />
    )}
  </Head>
);

export default Meta;
